# Overview

The verdict for this run, and the alert answered in one line.

- **The duplicate-title verdict** says whether the groups at or above the
  threshold were already in the reference run (*recurring* — the annual re-bids
  that make most of these alerts false positives), whether this run introduced
  one (*new*), or whether nothing reached the threshold (*clear*, naming the
  threshold it was checked against, so silence is never mistaken for a clean
  bill).
- **Copy triage note** yields text naming both runs, the policy version and
  hash, and the build. It ends by stating that no hold was released by this
  tool, because releasing one is a manual action in the pipeline.

The tiles count records, not problems: added, removed, changed and unchanged
are drift, and drift is not by itself a fault.

**Fill rate across runs** puts this run in the context of the earlier runs of the
same source this browser still holds. It charts only fields whose fill rate
actually moved, oldest to newest, on a fixed 0–100% scale so one field's line is
comparable with the next; a run where nothing moved says so in a sentence.

Two things it is not. It is not a history: the run cache is bounded, so the
window is whatever survived eviction, and the panel says how many runs it drew
from. And it is not a verdict — a fill rate moves for legitimate reasons as
often as for broken ones.
